<template>
  <div class="mdl-grid">
    <div class="mdl-card mdl-cell mdl-cell--8-col mdl-shadow--2dp">
      <!--<div class="mdl-card fill">-->
        <div class="mdl-card__title">
          <h2 class="mdl-card__title-text">{{'login.label.title' | label}}</h2>
        </div>
        <div class="mdl-card__supporting-text mdl-card--expand">
          <validator name="loginValidator">
            <form novalidate>
              <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill">
                <input class="mdl-textfield__input" type="text" id="username"
                v-model="credentials['username']" initial="off" v-validate:username="['required']" @keyup="clearCredentialsValidation()">
                <label class="mdl-textfield__label" for="username">{{'login.label.username' | label}}</label>
                <span class="validation-error mdl-textfield__error" v-if="$loginValidator.username.required">{{'login.label.username.validation' | label}}</span>
                <span class="validation-error mdl-textfield__error margin-bottom" v-if="showCredentialsValidation">{{credentialsValidationMessage | label}}</span>
              </div>
              <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill">
                <div class='iconized'>
                  <input class="mdl-textfield__input" :type="emailInputType" id="password"
                  v-model="credentials['password']" initial="off" v-validate:password="['required']" @keyup="clearCredentialsValidation()">
                  <span class="fas" :class="{'fa-eye': isFaEye, 'fa-eye-slash': isFaEyeSlash}"  @click="toggleShowEmail">&nbsp;</span>
                </div>
                <label class="mdl-textfield__label" for="password">{{'login.label.password' | label}}</label>
                <span class="validation-error mdl-textfield__error" v-if="$loginValidator.password.required">{{'login.label.password.validation' | label}}</span>
              </div>
              <div id="captcha-root">
                <vue-recaptcha v-ref:recaptcha v-on:verify="onVerify" v-on:expired="onExpired" :options="opts"></vue-recaptcha>
                <span class="validation-error mdl-textfield__error margin-bottom" v-if="showCaptchaValidation">{{captchaValidationMessage | label}}</span>
              </div>
            </form>
          </validator>
        </div>
        <div class="mdl-card__actions">
          <div class="card-grid mdl-grid">
            <div class="mdl-cell mdl-cell--8-col">
              <div class="link" v-on:click="forgotPassword()">{{'login.link.forgotPassword' | label}}</div>
            </div>
            <div class="mdl-cell mdl-cell--4-col">
              <div class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored fill"
                v-on:click="validate(credentials)">
                {{'login.button.login' | label}}
              </div>
            </div>
          </div>
        </div>
      <!--</div>-->
    </div>
    <div v-if="admin === 'false'" class="mdl-card mdl-cell mdl-cell--4-col mdl-shadow--2dp">
      <div class="mdl-card__title">
        <h4 class="mdl-card__title-text">{{'login.label.notamember.title' | label}}</h4>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand">
        {{{'login.text.notamember' | label}}}
      </div>
      <div class="mdl-card__actions">
        <div class="mdl-grid">
            <div class="mdl-cell mdl-cell--12-col mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
                 v-on:click="proceed()">
              {{'login.button.notamember' | label}}
            </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  var config = require('common/config')
  var vueRecaptcha = require('c/components/recaptcha/recaptcha.vue')
  module.exports = {
    ready: function () {
      window.componentHandler.upgradeAllRegistered()
    },
    props: ['admin'],
    components: {
      'vue-recaptcha': vueRecaptcha
    },
    methods: {
      validate: function (credentials) {
        var self = this
        self.clearCaptchaValidation()
        this.$validate(true, function () {
          if (self.$loginValidator.invalid || !self.recaptcha) {
            if (self.$loginValidator.invalid) {
              self.resetRecaptcha()
            }
            if (!self.recaptcha) {
              self.showCaptchaValidation = true
            }
            return
          }
          self.$dispatch('login-valid', credentials)
        })
      },
      proceed: function () {
        // this.$router.go('/app/newdelayedpub') to separate registration process from first message
        this.$router.go('/app/register')
      },
      forgotPassword: function () {
        this.$dispatch('forgot-password')
      },
      clearCredentialsValidation: function () {
        this.credentialsValidationMessage = ''
        this.showCredentialsValidation = false
      },
      clearCaptchaValidation: function () {
        this.captchaValidationMessage = ''
        this.showCaptchaValidation = false
      },
      onVerify: function (response) {
        this.recaptcha = true
        this.credentials.recaptchaData = response
      },
      onExpired: function () {
        console.log('Expired')
      },
      resetRecaptcha: function () {
        this.$refs.recaptcha.reset() // Direct call reset method
        this.recaptcha = false
        // this.$broadcast('recaptchaReset'); // Or broadcast event
      },
      toggleShowEmail: function () {
        this.emailInputType = (this.isFaEye ? 'text' : 'password')
        this.isFaEye = !this.isFaEye
        this.isFaEyeSlash = !this.isFaEyeSlash
      }
    },
    events: {
      'credentials-validation-fail': function (data) {
        this.credentialsValidationMessage = data
        this.showCredentialsValidation = true
        this.resetRecaptcha()
      },
      'captcha-validation-fail': function (data) {
        this.captchaValidationMessage = data
        this.showCaptchaValidation = true
        this.resetRecaptcha()
      }
    },
    data: function () {
      return {
        credentials: {
          username: '',
          password: '',
          recaptchaData: ''
        },
        showCredentialsValidation: false,
        credentialsValidationMessage: '',
        showCaptchaValidation: false,
        captchaValidationMessage: '',
        opts: {
          sitekey: config.recaptcha.sitekey
        },
        recaptcha: false,
        isFaEye: true,
        isFaEyeSlash: false,
        emailInputType: 'password'
      }
    }
  }
</script>

<style scoped>
  .login-form {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// LoginForm.vue?4376ed8d